import { useQuery, useQueryClient } from "@tanstack/react-query";
import { List } from "antd";
import moment from "moment";
import React, { useEffect } from "react";
import { MdOutlineNotificationsActive } from "react-icons/md";
import { resetNotification } from "../../api/apiCallManager";
import useNotifications from "../../components/hooks/useNotifications";

const IndexOfNotification = () => {
  const queryClient = useQueryClient();
  const {
    data: notifications = [],
    isLoading,
    isError,
    error,
  } = useNotifications();
  const { data, refetch } = useQuery({
    queryKey: ["resetNotification_"],
    queryFn: resetNotification,
    enabled: false, // Prevents automatic execution
  });

  useEffect(() => {
    const timer = setTimeout(() => {
      refetch(); // Call API after 2s
    }, 1000);
    return () => clearTimeout(timer); // Cleanup
  }, []);
  if (data?.statusCode == 200) {
    queryClient.invalidateQueries({ queryKey: ["notifications_"] });
  }
  return (
    <div className="p-3 pt-5">
      <List
        loading={isLoading}
        pagination={{ hideOnSinglePage: 10, position: "bottom", align: "end" }}
        dataSource={notifications}
        renderItem={(item) => (
          <List.Item
            key={item.notification_id}
            className="rounded-md mb-4 bg-[#fcfdff] border-[1.5px] border-[#e5e5e5]"
          >
            <List.Item.Meta
              className="py-1 px-5"
              title={
                <div>
                  <div className="flex items-center pb-2 ">
                    <MdOutlineNotificationsActive size={19} color="#005eb8" />
                    <h2 className="font-medium  mx-2 text-[15px]  ">
                      {item.title || "Notification"}
                    </h2>
                  </div>
                  <hr></hr>
                </div>
              }
              description={
                <div className="pt-2">
                  <p className=" text-gray-500 ">
                    <span className=" font-semibold">Description: </span>
                    {item.description || "No description available"}
                  </p>
                  <div className="flex justify-between items-center pt-2">
                    <p className="text-gray-400  text-[13px]  ">
                      {/* Created by: {item.created_by} */}
                    </p>

                    <p className="text-gray-400  text-[13px] ">
                      {moment
                        .utc(item.created_time)
                        .local()
                        .format("h:mm A, DD MMM ")}
                    </p>
                  </div>
                </div>
              }
            />
          </List.Item>
        )}
      />
    </div>
  );
};

export default IndexOfNotification;
